import useSWR from "swr";
import { apiUrl, invoicesApiUrl } from "../Config/Url";

export const useDashboard = () => {
  return useSWR(`${apiUrl}/invoice/api/admin/dashboard`);
};
